import DOMPurify from "dompurify";
import language from "../localization";
import feeFields from "../config/institutionalFeeFields.json";

export function sanitizeInstitutionalHtml(html) {
  const safe = DOMPurify.sanitize(typeof html === "string" ? html : "", {
    USE_PROFILES: { html: true },
    ADD_ATTR: ["target"],
    FORBID_TAGS: ["style", "form", "input", "button", "select", "textarea", "iframe", "video", "audio"],
    FORBID_ATTR: ["style", "id", "name"],
  });
  const doc = new DOMParser().parseFromString(safe, "text/html");
  // CMS headings belong below the page's H1 and section H2, not beside them.
  doc.querySelectorAll("h1,h2").forEach((heading) => {
    const replacement = doc.createElement("h3");
    replacement.innerHTML = heading.innerHTML;
    heading.replaceWith(replacement);
  });
  doc.querySelectorAll('a[target="_blank"]').forEach((link) => link.setAttribute("rel", "noopener noreferrer"));
  doc.querySelectorAll("img").forEach((image) => {
    image.loading = "lazy";
    image.decoding = "async";
    if (!image.hasAttribute("alt")) image.alt = "";
  });
  return doc.body.innerHTML;
}

export function sanitizeContactAddressHtml(html, compact = false) {
  const safe = DOMPurify.sanitize(typeof html === "string" ? html : "", {
    ALLOWED_TAGS: ["p", "br", "strong", "b", "em", "i", "u", "s", "span"],
    ALLOWED_ATTR: [],
  });
  const doc = new DOMParser().parseFromString(safe, "text/html");
  doc.querySelectorAll("p").forEach((paragraph) => {
    if (!paragraph.textContent.trim()) paragraph.remove();
    else if (compact) paragraph.replaceWith(...paragraph.childNodes, doc.createTextNode(" "));
  });
  if (compact) {
    doc.querySelectorAll("br").forEach((lineBreak) => lineBreak.replaceWith(doc.createTextNode(" ")));
  }
  return doc.body.innerHTML.trim();
}

export function normalizeAcademicYear(value) {
  return String(value || "").trim().replace(/[۰-۹٠-٩]/g, (digit) => String(digit.charCodeAt(0) - (digit >= "۰" ? 1776 : 1632)));
}

export function formatFeeValue(record, field, locale) {
  const value = record[field];
  if (value === null || value === undefined || value === "" || !Number.isFinite(Number(value))) return language.institution_not_published;
  const options = field === "discountPercentage" ? { style: "percent", maximumFractionDigits: 2 }
    : field === "credits" ? { maximumFractionDigits: 2 }
      : { ...(/^[A-Z]{3}$/.test(record.currency) ? { style: "currency", currency: record.currency } : {}), minimumFractionDigits: 2, maximumFractionDigits: 2 };
  return new Intl.NumberFormat(locale, options).format(field === "discountPercentage" ? Number(value) / 100 : Number(value));
}

export const FEE_FIELDS = feeFields;

export const pageQuery = (params = {}) => new URLSearchParams(Object.entries(params).filter(([, value]) => value !== "" && value !== null && value !== undefined)).toString();
